// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1z52y","alertIcon":"ConfirmModal_alertIcon__2emsd"};